import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import IframeEditor from '../../../components/Editor/IframeEditor';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			editableIframes,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { page, id } = ownProps;
	const { src, isVisible } = editableIframes[page][id];

	return {
		src,
		isActive: id === activeItem.id && page === activeItem.page,
		isVisible,
		isEditPanelDisplayed,
	};
};

export default connect(mapStateToProps)(IframeEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/IframeEditor/index.tsx